var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false},on:{"addEvent":function($event){return _vm.$router.push({name: 'addMerchant'})}}},[_vm._v("المتاجر المحذوفة")]),_c('main-table',{attrs:{"baseURL":_vm.VUE_APP_MARKETPLACE_LINK,"fields":_vm.fields,"list_url":"admin/stores/deleted-stores","reloadData":_vm.reloadTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }